"use strict";
var Observable_1 = require("../../Observable");
var windowToggle_1 = require("../../operator/windowToggle");
Observable_1.Observable.prototype.windowToggle = windowToggle_1.windowToggle;
//# sourceMappingURL=windowToggle.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/windowToggle.js
 ** module id = 441
 ** module chunks = 1
 **/